import { render, staticRenderFns } from "./TournamentResults.vue?vue&type=template&id=17fa2afc&scoped=true&"
import script from "./TournamentResults.vue?vue&type=script&lang=js&"
export * from "./TournamentResults.vue?vue&type=script&lang=js&"
import style0 from "./TournamentResults.vue?vue&type=style&index=0&id=17fa2afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa2afc",
  null
  
)

export default component.exports